export class Utils {
  static convertDataValue(balance: any): any {
    const KO = 1024;
    const MO = KO * 1024;
    const GO = MO * 1024;
    balance = Number(balance);
    if (balance > GO) {
      return { value: balance / GO, unit: 'Go' };
    }
    if (balance > MO) {
      return { value: balance / MO, unit: 'Mo' };
    }
    if (balance > KO) {
      return { value: balance / KO, unit: 'Ko' };
    }
    return { value: balance, unit: 'O' };
  }
  static dateFromTXnId(txnId: string) {
    const els: string[] = txnId.split(/\./);
    const y = (20 + els[0].substring(2, 4));
    const m = (els[0].substring(4, 6));
    const d = (els[0].substring(6, 8));
    const h = (els[1].substring(0, 2));
    const min = (els[1].substring(2, 4));
    console.log(txnId, y, m, d, h, min);
    return new Date(Number(y), Number(m), Number(d), Number(h), Number(min));
    // return d + '-' + m + '-' + y + ' ' + h + ':' + min;
  }
  static parseComOfferRi(comOffer) {
    switch (comOffer) {
      case 'SPPERSONNELORANGE':
        return 'Personnel Orange';
      default:
        return 'Utilisareur Orange';
    }
  }
  static parseUnitType(unit) {
    if (!unit) {
      return '';
    }
    if (unit === 'SECONDS') {
      return 'SEC';
    }
    if (unit === 'MONEY') {
      return 'FCFA';
    }
    if (unit === 'QUANTITY') {
      return '';
    }
    return unit;
  }
  static parseClientStatut(statut) {
    switch (statut) {
      case 'Avalider':
        return 'À Valider';
      case 'Identifier':
        return 'Identifié';
      default:
        return statut;
    }
  }
  static parseAccesResCode(accesResCode) {
    switch (accesResCode) {
      case 'Principal':
        return 'Compte Principal';
      case 'Forfait_On_Net':
        return 'Forfait Internet En Ligne';
      case 'Forfait_SMS_Illimite':
        return 'Forfait SMS Illimite';
      case 'Forfait_National':
        return 'Forfait Sewa';
      case 'Forfait_Bonus_Data':
        return 'Bonus Internet';
      case 'Forfait_Data':
        return 'Forfait Internet';
      case 'Bonus_vers_Orange':
        return 'Bonus vers Orange';
      case 'Bonus_SMS':
        return 'Bonus SMS';
      default:
        return accesResCode;
    }
  }

  static parseKeyValuesString(ds: string): { [key: string]: any } {
    const dataToParse = (ds || '').replace(/\\[;]/g, '&[&,]').replace(/\\[:]/g, '&[&,,]');
    console.log('dataToParse::', dataToParse);
    const dataEls: string[] = dataToParse.split(/;/);
    console.log('dataEls::', dataEls);
    const data = {};
    const parseSemiColon = (str: string) => {
      const d = {};
      const els: string[] = str.split(/:/, 2);
      console.log('els::', els);
      if (els.length < 2) {
        return els[0].trim().replace(/&\[&,,\]/g, ':').replace(/&\[&,\]/g, ';');
      }
      const remain = els.slice(1);
      console.log('remain::', remain);
      d[els[0].toLowerCase().trim()] = parseSemiColon(remain.join(':'));
      console.log('remain::', remain);
      return d;
    };
    if (dataEls.length >= 1) {
      dataEls.forEach(d => {
        const els: string[] = d.split(/:/);
        if (els.length < 2) {
          return;
        }
        const remain = els.slice(1);
        data[els[0].toLowerCase().trim()] = parseSemiColon(remain.join(':'));
      });
    }
    return data;
  }
}
